import Vue from 'vue'

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)
